import cn from 'classnames';
import { FC, ReactNode, useState } from 'react';
import { ChevronDownIcon } from '../../assets/svg/chevron-down';
import { useQueryParams } from '../../hooks/use-query-params';
import { Tooltip } from '../tooltip/tooltip';
import s from './dropdown-selector.module.css';

type Option = {
  label: ReactNode;
  value: string;
  icon?: ReactNode;
};

interface Props {
  label?: ReactNode;
  options: Option[];
  selectorKey: string;
  className?: string;
}

export const DropdownSelector: FC<Props> = (props) => {
  const { options, label, className, selectorKey } = props;
  const [open, setOpen] = useState(false);
  const { getQueryParams, addQueryParams } = useQueryParams();
  const params = getQueryParams();

  const handleItemClick = (value: string) => {
    addQueryParams({ [selectorKey]: value });
  };

  const selectedKey = params[selectorKey];
  const selected = options.find((item) => item.value === selectedKey);
  const selectedIcon = selected?.icon || options[0].icon;

  return (
    <Tooltip
      offset={12}
      wrapperClassName={cn(s.feature, className)}
      optionsWrapperClassName={s.options}
      open={open}
      onOpen={setOpen}
      trigger={
        <div role="button" className={cn(s.button)}>
          {selectedIcon}
          <span className="hide__M hide__S">{label}</span>
          <ChevronDownIcon className={cn(s.chevron, open && s.open, 'hide__M hide__S')} />
        </div>
      }
    >
      <ul className={s.list}>
        {options.map(({ label, value, icon }, index) => (
          <li key={`${value}-${index}`} className={s.item} onClick={() => handleItemClick(value)}>
            {label}
            {icon}
          </li>
        ))}
      </ul>
    </Tooltip>
  );
};
